import React from "react";
import { useState } from "react";
import styled, { keyframes } from "styled-components";
import FaceBookIcon from "../../../../assets/images/Facebook.png";
import YouTubleIcon from "../../../../assets/images/YouTube.png";
import InstagramIcon from "../../../../assets/images/Instagram.png";
import TwitterIcon from "../../../../assets/images/Twitter.png";
import LinkedInIcon from "../../../../assets/images/LinkedIn.png";
import IamcLogo from "../../../../assets/images/Iamclogo.svg";
import Map from "../../../../assets/images/Map.png";
import { navigate } from "@reach/router";
// import useCartCount from "../../../../hooks/useCartCount";



const Footer = ({ top = true }) => {
  // const { setScrollTick, setContactScrollTick, setHomeScrollTick } =
  //   useCartCount();

  const [openIndex, setOpenIndex] = useState(null);

  const toggleSection = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // const footerData = {
  //   quickLinks: [
  //     { name: "Home", href: "#home" },
  //     { name: "About Us", href: "about-us" },
  //     { name: "Contact Us", href: "#enquire-now" },
  //     { name: "Privacy & Policy", href: "/privacy-policy", type: true },
  //     { name: "Terms & Condition", href: "terms-and-conditions", type: true },
  //   ],

  //   services: [
  //     {
  //       name: "Online Dispute Resolution",
  //       href: "#our-offerings",
  //       section: "our-offerings",
  //     },
  //     {
  //       name: "Case Management",
  //       href: "#case-management",
  //       section: "our-offerings",
  //     },
  //     {
  //       name: "Live Transcription",
  //       href: "#transcription",
  //       section: "our-offerings",
  //     },
  //     {
  //       name: "ODR Platform Deployments",
  //       href: "#odr",
  //       section: "our-offerings",
  //     },
  //   ],

  //   onlineDispute: [
  //     { name: "Negotiation", href: "/negotiation-rules" },
  //     { name: "Mediation", href: "/mediation-rules" },
  //     { name: "Arbitration", href: "/arbitration-rules" },
  //   ],
  //   neutrals: [
  //     { name: "Arbitrators", href: "/neutral/arbitrators" },
  //     { name: "Mediators", href: "/neutral/mediators" },
  //     {
  //       name: "Login as Neutral",
  //       href: process.env.REACT_APP_NEUTRAL_BASE_URL,
  //     },
  //   ],
  //   training: [
  //     {
  //       name: "Corporate Short Programme",
  //       href: "/training/corporate-short-programme",
  //     },
  //     {
  //       name: "Mediation Training Programme",
  //       href: "/training/mediation-training-programme",
  //     },
  //     { name: "World of Mediation", href: "/training/world-of-mediation" },
  //   ],
  //   resources: [
  //     { name: "Blogs", href: "/resources/blogs" },
  //     { name: "Webinars", href: "/resources/webinar-videos" },
  //     { name: "Model Clauses", href: "/resources/model-clauses" },
  //     { name: "Awards", href: "/resources/awards" },
  //   ],
  // };

  const socialLinks = [
    {
      name: "Facebook",
      icon: FaceBookIcon,
      href: "https://www.facebook.com/IAMCHYD#",
      color: "#1877F2",
    },
    {
      name: "YouTube",
      icon: YouTubleIcon,
      href: "https://www.youtube.com/channel/UCgfG0-n4WzsFwVly_HhKtPQ",
      color: "#FF0000",
    },
    {
      name: "Twitter",
      icon: TwitterIcon,
      href: "https://x.com/IAMCHyderabad",
      color: "#1DA1F2",
    },
    {
      name: "Instagram",
      icon: InstagramIcon,
      href: "https://www.instagram.com/iamc.hyderabad",
      color: "linear-gradient(45deg, #F58529, #DD2A7B, #8134AF)",
    },
    {
      name: "LinkedIn",
      icon: LinkedInIcon,
      href: " https://www.linkedin.com/company/iamch/?viewAsMember=true",
      color: "#0A66C2",
    },
  ];

  return (
    <FooterContainer {...{ top }}>
      <FooterHeader>
        <Logo>
          <LogoImage src={IamcLogo} alt="IAMC" />
        </Logo>
        {/* <SocialLinks>
          {socialLinks.map((social, index) => (
            <SocialIcon
              key={index}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconImage src={social.icon} alt={social.name} />
            </SocialIcon>
          ))}
        </SocialLinks> */}
        <SocialLinks>
          {socialLinks.map((social, index) => (
            <SocialIcon
              key={index}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              bg={social.color}
            >
              <IconImage src={social.icon} alt={social.name} />
            </SocialIcon>
          ))}
        </SocialLinks>
      </FooterHeader>

      <FooterContent>
        <FooterGrid>
          {/* <FooterColumn delay={0}>
            <ColumnTitle>Quick Links</ColumnTitle>
            <LinkList>
              {footerData.quickLinks.map((link, index) => (
                <LinkItem key={index}>
                  <FooterLink
                    onClick={() => {
                      if (link.type) {
                        window.open(link.href);
                      } else if (link.name === "Contact Us") {
                        navigate(link.href);
                        setContactScrollTick((prev) => prev + 1);
                      } else if (link.name === "Home") {
                        navigate(link.href);
                        setHomeScrollTick((prev) => prev + 1);
                      } else {
                        navigate(link.href);
                      }
                    }}
                  >
                    {link.name}
                  </FooterLink>
                </LinkItem>
              ))}
            </LinkList>
          </FooterColumn>

          <FooterColumn delay={1}>
            <ColumnTitle>Services</ColumnTitle>
            <LinkList>
              {footerData.services.map((link, index) => (
                <LinkItem key={index}>
                  <FooterLink
                    onClick={() => {
                      navigate(link.href);
                      setScrollTick((prev) => prev + 1);
                    }}
                  >
                    {link.name}
                  </FooterLink>
                </LinkItem>
              ))}
            </LinkList>
          </FooterColumn>

          <FooterColumn delay={2}>
            <ColumnTitle>Online Dispute Resolution</ColumnTitle>
            <LinkList>
              {footerData.onlineDispute.map((link, index) => (
                <LinkItem key={index}>
                  <FooterLink
                    onClick={() =>
                      link.name === "Login as Neutral"
                        ? window.open(link.href)
                        : navigate(link.href)
                    }
                  >
                    {link.name}
                  </FooterLink>
                </LinkItem>
              ))}
            </LinkList>
          </FooterColumn>

          <FooterColumn delay={3}>
            <ColumnTitle>Neutrals</ColumnTitle>
            <LinkList>
              {footerData.neutrals.map((link, index) => (
                <LinkItem key={index}>
                  <FooterLink onClick={() => navigate(link.href)}>
                    {link.name}
                  </FooterLink>
                </LinkItem>
              ))}
            </LinkList>
          </FooterColumn>

          <FooterColumn delay={4}>
            <ColumnTitle>Training</ColumnTitle>
            <LinkList>
              {footerData.training.map((link, index) => (
                <LinkItem key={index}>
                  <FooterLink onClick={() => navigate(link.href)}>
                    {link.name}
                  </FooterLink>
                </LinkItem>
              ))}
            </LinkList>
          </FooterColumn>

          <FooterColumn delay={5}>
            <ColumnTitle>Resources</ColumnTitle>
            <LinkList>
              {footerData.resources.map((link, index) => (
                <LinkItem key={index}>
                  <FooterLink onClick={() => navigate(link.href)}>
                    {link.name}
                  </FooterLink>
                </LinkItem>
              ))}
            </LinkList>
          </FooterColumn> */}

          {/* <FooterColumn>
            <ColumnTitle onClick={() => toggleSection(0)}>
              Quick Links
              <span>{openIndex === 0 ? "−" : "+"}</span>
            </ColumnTitle>

            <LinkList open={openIndex === 0}>
              {footerData.quickLinks.map((link, index) => (
                <LinkItem key={index}>
                  <FooterLink onClick={() => navigate(link.href)}>
                    {link.name}
                  </FooterLink>
                </LinkItem>
              ))}
            </LinkList>
          </FooterColumn>
          <FooterColumn>
            <ColumnTitle onClick={() => toggleSection(1)}>
              Services
              <span>{openIndex === 1 ? "−" : "+"}</span>
            </ColumnTitle>

            <LinkList open={openIndex === 1}>
              {footerData.services.map((link, index) => (
                <LinkItem key={index}>
                  <FooterLink onClick={() => navigate(link.href)}>
                    {link.name}
                  </FooterLink>
                </LinkItem>
              ))}
            </LinkList>
          </FooterColumn>
          <FooterColumn>
            <ColumnTitle onClick={() => toggleSection(2)}>
              Online Dispute Resolution
              <span>{openIndex === 2 ? "−" : "+"}</span>
            </ColumnTitle>

            <LinkList open={openIndex === 2}>
              {footerData.onlineDispute.map((link, index) => (
                <LinkItem key={index}>
                  <FooterLink onClick={() => navigate(link.href)}>
                    {link.name}
                  </FooterLink>
                </LinkItem>
              ))}
            </LinkList>
          </FooterColumn>
          <FooterColumn>
            <ColumnTitle onClick={() => toggleSection(3)}>
              Neutrals
              <span>{openIndex === 3 ? "−" : "+"}</span>
            </ColumnTitle>

            <LinkList open={openIndex === 3}>
              {footerData.neutrals.map((link, index) => (
                <LinkItem key={index}>
                  <FooterLink onClick={() => navigate(link.href)}>
                    {link.name}
                  </FooterLink>
                </LinkItem>
              ))}
            </LinkList>
          </FooterColumn>

          <FooterColumn>
            <ColumnTitle onClick={() => toggleSection(4)}>
              Training
              <span>{openIndex === 4 ? "−" : "+"}</span>
            </ColumnTitle>

            <LinkList open={openIndex === 4}>
              {footerData.training.map((link, index) => (
                <LinkItem key={index}>
                  <FooterLink onClick={() => navigate(link.href)}>
                    {link.name}
                  </FooterLink>
                </LinkItem>
              ))}
            </LinkList>
          </FooterColumn>
          <FooterColumn>
            <ColumnTitle onClick={() => toggleSection(5)}>
              Resources
              <span>{openIndex === 5 ? "−" : "+"}</span>
            </ColumnTitle>

            <LinkList open={openIndex === 5}>
              {footerData.resources.map((link, index) => (
                <LinkItem key={index}>
                  <FooterLink onClick={() => navigate(link.href)}>
                    {link.name}
                  </FooterLink>
                </LinkItem>
              ))}
            </LinkList>
          </FooterColumn> */}
        </FooterGrid>
      </FooterContent>

      <ContactSection>
        {/* <ContactCard3D as="a" href="tel:+919500909888">
          <ContactTitle>Phone</ContactTitle>
          <ContactInfo>040 29353910 / 040 29353911</ContactInfo>
          <ContactInfo>040 29353912 / 040 29353913</ContactInfo>
          <GetDirection>{"📞 Call Now"}</GetDirection>
        </ContactCard3D> */}
        <ContactCard3D>
              <ContactTitle>Phone</ContactTitle>

              <ContactInfo
                as="a"
                href="tel:04029353910"
                style={{ textDecoration: "none" }}
              >
                040 29353910
              </ContactInfo> <br />

              <ContactInfo
                as="a"
                href="tel:04029353911"
                style={{ textDecoration: "none" }}
              >
                040 29353911
              </ContactInfo><br />

              <ContactInfo
                as="a"
                href="tel:04029353912"
                style={{ textDecoration: "none" }}
              >
                040 29353912
              </ContactInfo><br />

              <ContactInfo
                as="a"
                href="tel:04029353913"
                style={{ textDecoration: "none" }}
              >
                040 29353913
              </ContactInfo><br />

              <GetDirection>📞 Call Now</GetDirection>
            </ContactCard3D>

        <ContactCard3D>
          <ContactTitle>Email</ContactTitle>
          <ContactInfo
            as="a"
            href="https://mail.google.com/mail/?view=cm&fs=1&to=Secretariat@iamch.org.in"
            style={{ textDecoration: "none" }}
          >
            For Case Management: <br /> Secretariat@iamch.org.in
          </ContactInfo><br />
          <ContactInfo
            as="a"
            href="https://mail.google.com/mail/?view=cm&fs=1&to=mahesh.pasham@iamch.org.in"
            style={{ textDecoration: "none" }}
          >
            IT Support:<br /> mahesh.pasham@iamch.org.in
          </ContactInfo>
          <GetDirection>{"✉️ Send Email"}</GetDirection>
        </ContactCard3D>

        <ContactCard3D
          as="a"
          href="https://www.google.com/maps/place/IAMC/@17.4235383,78.3444205,960m/data=!3m3!1e3!4b1!5s0x3bcb93874d2c2755:0x2f9f2f865e0efeeb!4m6!3m5!1s0x3bcb9597100cf611:0xd7d08d87720fd6b9!8m2!3d17.4235332!4d78.3470008!16s%2Fg%2F11smhb8_hf?entry=ttu&g_ep=EgoyMDI2MDcyNy4wIKXMDSoASAFQAw%3D%3D"
          target="_blank"
          rel="noopener noreferrer"
        >
          <ContactTitle>Address</ContactTitle>
          <ContactInfo>
            International Arbitration & Mediation Centre<br />
            21st & 22nd Floor, Vijay Krishna Towers,<br />
            Financial District, Nanakramguda<br />
            Hyderabad, Telangana-500032<br />
            Next to Fairfield by Marriott
          </ContactInfo>
          <GetDirection>
            <img src={Map} alt="Location Map" />
          </GetDirection>
        </ContactCard3D>
      </ContactSection>

      <FooterBottom>
        <Copyright>Copyright © JUSTACT 2026</Copyright>
      </FooterBottom>

      <ScrollTopButton
        onClick={scrollToTop}
        role="img"
        aria-label="Scroll to top"
      >
        ▲
      </ScrollTopButton>
    </FooterContainer>
  );
};

export default Footer;

const ScrollTopButton = styled.button`
  position: absolute;
  bottom: 20px;
  right: 20px;

  width: 46px;
  height: 46px;
  border-radius: 50%;
  border: none;

  background: #0c2641ff;
  color: #ffffff;
  font-size: 22px;
  font-weight: bold;

  cursor: pointer;
  z-index: 10;

  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px);
    background: #084a91;
  }

  @media (max-width: 768px) {
    width: 42px;
    height: 42px;
    font-size: 20px;
    bottom: 16px;
    right: 16px;
  }

  @media (max-width: 480px) {
    width: 38px;
    height: 38px;
    font-size: 18px;
    bottom: 14px;
    right: 14px;
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const FooterContainer = styled.footer`
  background: #293462;
  color: white;
  padding: 60px 20px 30px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  position: relative;
  overflow: hidden;
  margin-top: ${({ top }) => (top ? "45px" : "0px")};

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    pointer-events: none;
  }

  @media (max-width: 1024px) {
    padding: 50px 20px 25px;
  }

  @media (max-width: 768px) {
    padding: 40px 16px 20px;
  }

  @media (max-width: 480px) {
    padding: 30px 12px 15px;
    margin-top: 30px;
  }

  @media (max-width: 360px) {
    padding: 25px 10px 12px;
  }
`;

const FooterHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 50px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  animation: ${fadeIn} 0.8s ease-out;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 25px;
    margin-bottom: 40px;
    padding-bottom: 25px;
  }

  @media (max-width: 480px) {
    gap: 20px;
    margin-bottom: 30px;
    padding-bottom: 20px;
  }

  @media (max-width: 360px) {
    gap: 15px;
    margin-bottom: 25px;
    padding-bottom: 15px;
  }
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  animation: ${slideUp} 0.8s ease-out 0.2s both;

  @media (max-width: 480px) {
    gap: 10px;
  }
`;

const LogoImage = styled.img`
  width: 220px;
  height: auto;
  max-height: 80px;
  object-fit: contain;
  display: block;

  @media (max-width: 768px) {
    width: 190px;
    max-height: 70px;
  }

  @media (max-width: 480px) {
    width: 160px;
    max-height: 60px;
  }

  @media (max-width: 360px) {
    width: 140px;
    max-height: 50px;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 15px;
  animation: ${slideUp} 0.8s ease-out 0.4s both;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 480px) {
    gap: 12px;
  }

  @media (max-width: 360px) {
    gap: 10px;
  }
`;

const SocialIcon = styled.a`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  background: ${({ bg }) => (bg.includes("gradient") ? bg : bg)};
  box-shadow:
    0 6px 14px rgba(0, 0, 0, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.35);

  transition: all 0.25s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-4px) scale(1.05);
    box-shadow:
      0 10px 24px rgba(0, 0, 0, 0.45),
      inset 0 2px 4px rgba(255, 255, 255, 0.4);
  }

  &:active {
    transform: translateY(-1px);
    box-shadow:
      0 4px 10px rgba(0, 0, 0, 0.4),
      inset 0 4px 6px rgba(0, 0, 0, 0.3);
  }

  @media (max-width: 480px) {
    width: 42px;
    height: 42px;
  }
`;

// const SocialIcon = styled.a`
//   width: 48px;
//   height: 48px;
//   border-radius: 50%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background: rgba(255, 255, 255, 0.12);
//   transition: all 0.3s ease;

//   &:hover {
//     background: rgba(255, 255, 255, 0.25);
//     transform: translateY(-3px);
//   }

//   @media (max-width: 768px) {
//     width: 44px;
//     height: 44px;
//   }

//   @media (max-width: 480px) {
//     width: 42px;
//     height: 42px;
//   }

//   @media (max-width: 360px) {
//     width: 38px;
//     height: 38px;
//   }
// `;

// const IconImage = styled.img`
//   width: 35px;
//   height: 35px;
//   object-fit: contain;

//   @media (max-width: 480px) {
//     width: 20px;
//     height: 20px;
//   }

//   @media (max-width: 360px) {
//     width: 18px;
//     height: 18px;
//   }
// `;

const IconImage = styled.img`
  width: 35px;
  height: 35px;
  object-fit: contain;

  @media (max-width: 768px) {
    width: 22px;
    height: 22px;
  }

  @media (max-width: 480px) {
    width: 25px;
    height: 25px;
  }
  @media (max-width: 360px) {
    width: 23px;
    height: 23px;
  }
`;

const FooterContent = styled.div`
  position: relative;
  margin-bottom: 50px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 3px;
  }

  @media (max-width: 1024px) {
    margin-bottom: 40px;
    padding-bottom: 25px;
  }

  @media (max-width: 768px) {
    margin-bottom: 35px;
    padding-bottom: 20px;
  }

  @media (max-width: 480px) {
    margin-bottom: 30px;
    padding-bottom: 15px;
  }
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 40px;
  position: relative;
  z-index: 2;
  min-width: 960px;

  @media (max-width: 1200px) {
    gap: 30px;
    min-width: 900px;
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    min-width: auto;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 25px;
  }
`;

const FooterColumn = styled.div`
  animation: ${slideUp} 0.8s ease-out ${(props) => 0.6 + props.delay * 0.1}s
    both;
  position: relative;
  min-width: 0;

  @media (max-width: 480px) {
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }
`;

// const ColumnTitle = styled.h3`
//   font-size: 1.2rem;
//   font-weight: 600;
//   color: #ffffff;
//   margin-bottom: 20px;
//   position: relative;
//   padding-bottom: 12px;

//   &::after {
//     content: "";
//     position: absolute;
//     left: 0;
//     bottom: 0;
//     width: 40px;
//     height: 2px;
//     background: rgba(255, 255, 255, 0.5);
//   }

//   @media (max-width: 1024px) {
//     font-size: 1.15rem;
//   }

//   @media (max-width: 768px) {
//     font-size: 1.1rem;
//     margin-bottom: 15px;
//     padding-bottom: 10px;
//   }

//   @media (max-width: 480px) {
//     font-size: 1.05rem;
//     margin-bottom: 12px;
//     padding-bottom: 8px;
//   }

//   @media (max-width: 360px) {
//     font-size: 1rem;
//   }
// `;

const ColumnTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 20px;

  span {
    display: none;
  }

  @media (max-width: 1024px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    span {
      display: block;
      font-size: 20px;
      font-weight: bold;
    }
  }
`;

// const LinkList = styled.ul`
//   list-style: none;
//   padding: 0;
//   margin: 0;
// `;

const LinkList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  /* Desktop – always visible */
  display: block;

  /* Tablet + Mobile – accordion */
  @media (max-width: 1024px) {
    max-height: ${({ open }) => (open ? "600px" : "0")};
    overflow: hidden;
    transition: max-height 0.35s ease;
  }
`;

const LinkItem = styled.li`
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 480px) {
    margin-bottom: 10px;
  }

  @media (max-width: 360px) {
    margin-bottom: 8px;
  }
`;

const FooterLink = styled.a`
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  position: relative;
  padding-left: 0;
  cursor: pointer;
  display: inline-block;
  line-height: 1.5;

  &:hover {
    color: #ffffff;
    padding-left: 8px;
  }

  &::before {
    content: "";
    position: absolute;
    left: -15px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 1px;
    background: #ffffff;
    transition: width 0.3s ease;
  }

  &:hover::before {
    width: 10px;
  }

  @media (max-width: 768px) {
    font-size: 0.92rem;
  }

  @media (max-width: 480px) {
    font-size: 0.9rem;
  }

  @media (max-width: 360px) {
    font-size: 0.88rem;
  }
`;

// Contact Info Section
const ContactSection = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  margin-bottom: 40px;
  animation: ${slideUp} 0.8s ease-out 1s both;

  @media (max-width: 1024px) {
    gap: 25px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
    margin-bottom: 30px;
  }

  @media (max-width: 480px) {
    gap: 15px;
    margin-bottom: 25px;
  }
`;

const ContactCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 15px;
  padding: 25px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  font-family: openSans-Regular, sans-serif;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    padding: 20px;
    border-radius: 12px;
  }

  @media (max-width: 480px) {
    padding: 18px;
    border-radius: 10px;
  }

  @media (max-width: 360px) {
    padding: 15px;
  }
`;

const ContactCard3D = styled(ContactCard)`
  cursor: pointer;
  text-decoration: none;
  color: inherit;

  background: linear-gradient(145deg, #2f3a6f, #252e55);
  box-shadow:
    0 8px 20px rgba(0, 0, 0, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.15);

  transition: all 0.25s ease;

  &:hover {
    transform: translateY(-6px);
    box-shadow:
      0 14px 30px rgba(0, 0, 0, 0.45),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
  }

  &:active {
    transform: translateY(-2px);
    box-shadow:
      0 6px 14px rgba(0, 0, 0, 0.4),
      inset 0 3px 6px rgba(0, 0, 0, 0.3);
  }
`;

// const GetDirection = styled.div`
//   margin-top: 5px;
//   font-size: 0.85rem;
//   font-weight: 600;
//   color: #cdd9ff;
// `;
const GetDirection = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;

  width: 120px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;

  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.35);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 1024px) {
    width: 70px;
    height: 40px;
    top: 18px;
    right: 18px;
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 25px;
    top: 16px;
    right: 16px;
  }

  @media (max-width: 480px) {
    position: relative;
    top: auto;
    right: auto;

    width: 90%;
    height: 80px;
    margin-top: 12px;
    border-radius: 10px;
  }

  @media (max-width: 360px) {
    height: 100px;
  }
`;

const ContactTitle = styled.h4`
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 10px;
  color: #ffffff;

  @media (max-width: 768px) {
    font-size: 1.05rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
    margin-bottom: 8px;
  }

  @media (max-width: 360px) {
    font-size: 0.95rem;
  }
`;

const ContactInfo = styled.p`
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none !important;
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 0.92rem;
  }

  @media (max-width: 480px) {
    font-size: 0.9rem;
    line-height: 1.5;
  }

  @media (max-width: 360px) {
    font-size: 0.88rem;
  }
`;

// Footer Bottom
const FooterBottom = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 25px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  animation: ${fadeIn} 0.8s ease-out 1.2s both;
  text-align: center;

  @media (max-width: 768px) {
    padding-top: 20px;
  }

  @media (max-width: 480px) {
    padding-top: 15px;
  }
`;

const Copyright = styled.p`
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  font-size: 0.9rem;

  @media (max-width: 480px) {
    font-size: 0.85rem;
  }

  @media (max-width: 360px) {
    font-size: 0.82rem;
  }
`;
